module.exports = __webpack_public_path__ + "static/media/Kristen_Scott.44a48907.png";